/* eslint-disable max-len */
export const cancelButtonId = 'CHURNKEY_CANCEL_BUTTON';

export const singleScriptInstall = `<script>
!function(){  
  if (!window.churnkey || !window.churnkey.created) {
    window.churnkey = { created: true };
    const a = document.createElement('script');
    a.src = 'https://assets.churnkey.co/js/app.js?appId=APP_ID';
    a.async = true;
    const b = document.getElementsByTagName('script')[0];
    b.parentNode.insertBefore(a, b);
  }
}();
</script>
`;

export const serverScriptInstall = `const crypto = require("crypto");
const API_KEY = "CK_SECRET"; // Your Churnkey API Key
const user_hash = crypto.createHmac(
  "sha256",
  API_KEY
).update(STRIPE_CUSTOMER_ID).digest("hex"); // Send to front-end
`;

export const serverScriptInstallRuby = `OpenSSL::HMAC.hexdigest(
  "sha256",
  CK_SECRET,
  STRIPE_CUSTOMER_ID
) #send to front-end
`;

export const serverScriptInstallPython = `import hmac
import hashlib
email_hash = hmac.new(
    CK_SECRET,
    STRIPE_CUSTOMER_ID,
    digestmod=hashlib.sha256
).hexdigest() # Send to front-end
`;

export const serverScriptInstallPhp = `hash_hmac(
    'sha256',
    STRIPE_CUSTOMER_ID,
    CK_SECRET
) // Send to front-end
`;

export const invokeChurnkeyFlow = `document.getElementById('BUTTON_ID').addEventListener('click', function () {
  window.churnkey.init('show', {
    customerId: 'STRIPE_CUSTOMER_ID',
    authHash: 'HMAC_HASH',
    appId: 'APP_ID',
    mode: 'live',
    provider: 'stripe'
  })
})
`;

/*
// replaced by unifiedManagedFlowScript
export const invokeChurnkeyManagedFlow = `document.getElementById('BUTTON_ID').addEventListener('click', function (event) {
  event.preventDefault();
  window.churnkey.managedFlow('show', {
    appId: 'APP_ID',
    mode: 'live',
    provider: 'stripe',
    prefilled: {
      // email: 'jane@example.com', optional
    }
  })
})
`;
*/

export const unifiedManagedFlowScript = `<script>
!function(){  
  if (!window.churnkey || !window.churnkey.created) {
    window.churnkey = { created: true };
    const a = document.createElement('script');
    a.src = 'https://assets.churnkey.co/js/app.js?appId=APP_ID';
    a.async = true;
    const b = document.getElementsByTagName('script')[0];
    b.parentNode.insertBefore(a, b);
  }
}();
document.getElementById('${cancelButtonId}').addEventListener('click', function (event) {
  event.preventDefault();
  window.churnkey.managedFlow('show', {
    appId: 'APP_ID',
    mode: 'live',
    provider: 'stripe',
    prefilled: {
      email: '',
    }
  })
})
</script>
`;

export const addButtonCode = `<button id="${cancelButtonId}">Cancel Subscription</button>`;

export const invokeChurnkeyFlowLite = `document.getElementById('BUTTON_ID').addEventListener('click', function () {
  window.churnkey.init('insight', {
    appId: 'APP_ID',
    customerAttributes: {
      email: 'hey@example.com',
    },
    onCancel: (customer, surveyResponse) => {
      console.log(customer, surveyResponse);
      // your customer logic for cancellation customer subscriptions
      cancelCustomerSubscription();
    }
  })
})
`;
